import { render, staticRenderFns } from "./group-view.vue?vue&type=template&id=79f6ad18&"
import script from "./group-view.vue?vue&type=script&lang=js&"
export * from "./group-view.vue?vue&type=script&lang=js&"
import style0 from "./group-view.vue?vue&type=style&index=0&id=79f6ad18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports